export default "__VITE_ASSET__CNKtT7fw__"